import React from "react";
import {cx} from "../../../lib/ClassSet";
import "./WaterContainerItem.css";

const WaterContainerItem = (props) => {

  let {data} = props;

  let classes = cx({
    "item": true,
    "inventory-water-container-list-item": true,
    "u-selected": props.selected
  })

  return (
    <tr className={classes} onClick={(e) => props.onClick(data, e)}>
      <td className="field f-id">{data.get("serial")}</td>
      <td className="field f-sku">{data.get("sku")}</td>
      <td className="field f-state">{data.get("state")}</td>
    </tr>
  )
}

export default WaterContainerItem;